import { Component, inject, OnInit } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { Input, Output, EventEmitter, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { getStoredAuthToken } from '../../../../core/auth/auth-token';
import { UserWatchListService } from '../../../../core/services/users/userWatchlist.service';
import { ToastService } from '../../../../layout/toast/toast.service';
import { LanguageService } from '../../../../core/services/language/language.service';

@Component({
  selector: 'app-kebab-watch-to-list-component',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './kebab-watch-to-list-component.html',
  styleUrl: './kebab-watch-to-list-component.scss'
})
export class KebabWatchToListComponent implements OnInit {

  @Input() data: any;
  @Output() toggleChange = new EventEmitter<any>();

  private readonly platformId = inject<Object>(PLATFORM_ID);
  private readonly router = inject(Router);
  private readonly toast = inject(ToastService);
  private readonly languageService = inject(LanguageService);
  private readonly userWatchListService = inject(UserWatchListService);
  private readonly http = inject(HttpClient);

  authToken: string = '';
  backendUrl: string = environment.backendUrl;

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.authToken = getStoredAuthToken();
  }

  addToWatchlist(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      const token = getStoredAuthToken();
      if (!token) {
        this.toast.warning(
          this.languageService.t('loginRequiredTitle') || 'Login Required',
          this.languageService.t('loginRequiredMessage') || 'Please log in to perform this activity.'
        );
        this.toggleChange.emit(this);
        this.router.navigate(['/auth'], { queryParams: { redirect: this.router.url || '/' } });
        return;
      }
    }

    const title = data?.title || data?.original_title || data?.name || 'Item';

    // Close menu immediately — good UX
    this.toggleChange.emit(this);

    // API call
    this.userWatchListService.addToUserWatchList(data).subscribe({
      next: () => {
        this.toast.success('Added to Watchlist', `"${title}" is now in your watchlist.`);
      },
      error: (err) => {
        console.error('Error adding to watchlist:', err);
        const msg = err?.status === 401 || err?.status === 404
          ? (this.languageService.t('loginRequiredMessage') || 'Please sign in to add to your watchlist.')
          : 'Could not add to watchlist. Please try again.';
        this.toast.error('Failed', msg);
      }
    });
  }
}
